var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row py-2" }, [
      _c("div", { staticClass: "col-lg-6 offset-lg-3 col-12" }, [
        _c("h2", [_vm._v("Choose Service")]),
        _vm._v(" "),
        _c("section", [
          _c("h3", [_vm._v("บริการล้างแอร์")]),
          _vm._v(" "),
          _c("div", { staticClass: "grid-container" }, [
            _c(
              "a",
              {
                attrs: {
                  href:
                    "https://www.q-chang.com/p/ac-cleaning-wall-type?sku=84c8e767-5bdc-3794-ac89-a7489afff95b&isPublished=false&channel=BeNeat"
                }
              },
              [
                _c("div", { staticClass: "card my-1 h-100" }, [
                  _c("img", {
                    staticClass: "card-img-top",
                    attrs: {
                      src:
                        "https://beneat-test.s3.ap-southeast-1.amazonaws.com/q_chang/ac_service_resized01_2023_01_25.png",
                      alt: ""
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "card-body px-2 py-3 d-flex justify-content-center align-items-center"
                    },
                    [
                      _c("div", { staticClass: "text-center text-dark" }, [
                        _c("b", [_vm._v("บริการล้างแอร์ผนัง")])
                      ])
                    ]
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                attrs: {
                  href:
                    "https://www.q-chang.com/p/ac-cleaning-celling-type?sku=c591e606-400f-3d67-8ea2-f47877731150&isPublished=false&channel=BeNeat"
                }
              },
              [
                _c("div", { staticClass: "card my-1 h-100" }, [
                  _c("img", {
                    staticClass: "card-img-top",
                    attrs: {
                      src:
                        "https://beneat-test.s3.ap-southeast-1.amazonaws.com/q_chang/ac_service_resized02_2023_01_30.jpg",
                      alt: ""
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "card-body px-2 py-3 d-flex justify-content-center align-items-center"
                    },
                    [
                      _c("div", { staticClass: "text-center text-dark" }, [
                        _c("b", [_vm._v("บริการล้างแอร์แขวน/ตั้งพื้น")])
                      ])
                    ]
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                attrs: {
                  href:
                    "https://www.q-chang.com/p/ac-cleaning-4-ways-cassette-type?sku=9a1da77a-2b27-3404-8277-7d2970cfcbd6&isPublished=false&channel=BeNeat"
                }
              },
              [
                _c("div", { staticClass: "card my-1 h-100" }, [
                  _c("img", {
                    staticClass: "card-img-top",
                    attrs: {
                      src:
                        "https://beneat-test.s3.ap-southeast-1.amazonaws.com/q_chang/ac_service_resized03_2023_01_30.jpg",
                      alt: ""
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "card-body px-2 py-3 d-flex justify-content-center align-items-center"
                    },
                    [
                      _c("div", { staticClass: "text-center text-dark" }, [
                        _c("b", [_vm._v("บริการล้างแอร์ 4 ทิศทาง")])
                      ])
                    ]
                  )
                ])
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _c("section", { staticClass: "mt-5 mb-2" }, [
          _c("h3", [_vm._v("บริการล้างเครื่องซักผ้า")]),
          _vm._v(" "),
          _c("div", { staticClass: "grid-container" }, [
            _c(
              "a",
              {
                attrs: {
                  href:
                    "https://www.q-chang.com/p/washer-cleaning-toploader?sku=3883039f-1014-3df1-bb20-76125152ab49&isPublished=false&channel=BeNeat"
                }
              },
              [
                _c("div", { staticClass: "card my-1 h-100" }, [
                  _c("img", {
                    staticClass: "card-img-top",
                    attrs: {
                      src:
                        "https://beneat-test.s3.ap-southeast-1.amazonaws.com/q_chang/wm_service_resized01_2023_01_25.png",
                      alt: ""
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "card-body px-2 py-3 d-flex justify-content-center align-items-center"
                    },
                    [
                      _c("div", { staticClass: "text-center text-dark" }, [
                        _c("b", [_vm._v("บริการล้างเครื่องซักผ้า (ฝาบน)")])
                      ])
                    ]
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                attrs: {
                  href:
                    "https://www.q-chang.com/p/washer-cleaning-frontloader?sku=d0d04c3f-4f67-31ed-9ba8-e8a0c5029631&isPublished=false&channel=BeNeat"
                }
              },
              [
                _c("div", { staticClass: "card my-1 h-100" }, [
                  _c("img", {
                    staticClass: "card-img-top",
                    attrs: {
                      src:
                        "https://beneat-test.s3.ap-southeast-1.amazonaws.com/q_chang/wm_service_resized02_2023_01_25.png",
                      alt: ""
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "card-body px-2 py-3 d-flex justify-content-center align-items-center"
                    },
                    [
                      _c("div", { staticClass: "text-center text-dark" }, [
                        _c("b", [_vm._v("บริการล้างเครื่องซักผ้า (ฝาหน้า)")])
                      ])
                    ]
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                attrs: {
                  href:
                    "https://www.q-chang.com/p/washer-and-dryer-cleaning?sku=78eee1db-3139-3ece-94c1-95d1abab62b3&isPublished=false&channel=BeNeat"
                }
              },
              [
                _c("div", { staticClass: "card my-1 h-100" }, [
                  _c("img", {
                    staticClass: "card-img-top",
                    attrs: {
                      src:
                        "https://beneat-test.s3.ap-southeast-1.amazonaws.com/q_chang/wm_service_resized03_2023_01_25.png",
                      alt: ""
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "card-body px-lg-2 py-3 d-flex justify-content-center align-items-center"
                    },
                    [
                      _c("div", { staticClass: "text-center text-dark" }, [
                        _c("b", [_vm._v("บริการล้างเครื่องซักอบผ้า (ฝาหน้า)")])
                      ])
                    ]
                  )
                ])
              ]
            )
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d337862a", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d337862a","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/qChang/Step2.vue
// module id = 2392
// module chunks = 0